/**
 * This file is responsible for handling the service calls for the account
 */
import store from "../store";
import {
	callAPI,
	chameau,
	createDefaultResource,
	DEFAULT_LIST_PARAMS,
	GATEWAY_PROXY,
	METHODS,
} from "utils/apiUtils";
import { DialogHandler } from "cakemail-ui-components/lib/react";
import { I18n, Translate } from "react-redux-i18n";
import React from "react";
import {
	SEGMENT_EVENTS,
	trackSegmentEvent,
} from "assets/js/const/SegmentEvents";
import fetchRoute from "utils/routes";
import { LIMIT_FEATURE, limitsFeaturesAccess } from "utils/LimitsAndFeatures";
import { deleteCacheKey, LOCAL_STORAGE_DATA } from "utils/localStorageUtil";

export function listTagsService(
	options = DEFAULT_LIST_PARAMS,
	successCallback = () => {},
	failureCallback = () => {}
) {
	options.perPage = 500;
	callAPI(
		{
			url: GATEWAY_PROXY + "/tags",
			method: METHODS.get,
			query: { account_id: store.getState().global.account.id, ...options },
		},
		successCallback,
		failureCallback
	);
}

export function deleteTagService(
	options = { tag: "" },
	successCallback = () => {},
	failureCallback = () => {}
) {
	callAPI(
		{
			url: GATEWAY_PROXY + `/tags/${options.tag}`,
			method: METHODS.delete,
			query: { account_id: store.getState().global.account.id },
		},
		(data) => {
			trackSegmentEvent(SEGMENT_EVENTS.TAG_DELETED, data);
			successCallback(data);
		},
		failureCallback
	);
}

export function updateTagService(
	options = { id: "", tag: "" },
	successCallback = () => {},
	failureCallback = () => {}
) {
	const { id, ...rest } = options;
	callAPI(
		{
			url: GATEWAY_PROXY + `/tags/${id}`,
			method: METHODS.patch,
			query: { account_id: store.getState().global.account.id },
			body: rest,
		},
		(data) => {
			trackSegmentEvent(SEGMENT_EVENTS.TAG_UPDATED, {
				previousTag: id,
				...data.data,
			});
			successCallback(data);
		},
		failureCallback
	);
}

export function getTagService(
	options = { id: "" },
	successCallback = () => {},
	failureCallback = () => {}
) {
	callAPI(
		{
			url: GATEWAY_PROXY + `/tags/${options.id}`,
			method: METHODS.get,
			query: { account_id: store.getState().global.account.id },
		},
		successCallback,
		failureCallback
	);
}

export function createTagService(
	options = { tag: "" },
	successCallback = () => {},
	failureCallback = () => {}
) {
	callAPI(
		{
			url: GATEWAY_PROXY + "/tags",
			method: METHODS.post,
			query: { account_id: store.getState().global.account.id },
			body: options,
		},
		(data) => {
			successCallback(data);
			trackSegmentEvent(SEGMENT_EVENTS.TAG_CREATED, data.data);
		},
		failureCallback
	);
}

export function tagMultipleContactService(
	options = { listId: "", contactIds: [], tags: [] },
	successCallback = () => {},
	failureCallback = () => {}
) {
	const { listId, contactIds, tags, json } = options;
	const queryChoice = json ? { json: json } : { contact_ids: contactIds };
	callAPI(
		{
			url: GATEWAY_PROXY + `/lists/${listId}/contacts/tag`,
			method: METHODS.post,
			query: { account_id: store.getState().global.account.id },
			body: { tags: tags, ...queryChoice },
		},
		(data) => {
			trackSegmentEvent(SEGMENT_EVENTS.CONTACT_TAGGED, {
				listId: listId,
				contactIds: contactIds,
				tags: tags,
				usingQueryFilter: !!queryChoice?.json,
			});
			successCallback(data);
		},
		failureCallback
	);
}

export function untagMultipleContactService(
	options = { listId: "", contactIds: [], tags: [] },
	successCallback = () => {},
	failureCallback = () => {}
) {
	const { listId, contactIds, tags, json } = options;
	const queryChoice = json ? { json: json } : { contact_ids: contactIds };
	callAPI(
		{
			url: GATEWAY_PROXY + `/lists/${listId}/contacts/untag`,
			method: METHODS.post,
			query: { account_id: store.getState().global.account.id },
			body: { tags: tags, ...queryChoice },
		},
		(data) => {
			trackSegmentEvent(SEGMENT_EVENTS.CONTACT_UNTAGGED, {
				listId: listId,
				contactIds: contactIds,
				tags: tags,
				usingQueryFilter: !!queryChoice?.json,
			});
			successCallback(data);
		},
		failureCallback
	);
}
